import axios from 'axios';
import MockAdapter from 'axios-mock-adapter';
import { LoginUsers, Users, Users_admin, Users_vip, Vip_Product, Vip_chongzhi,} from './data/user';
let _Users = Users;
let _Users_admin = Users_admin;
let _Users_vip = Users_vip;
let _Vip_Product = Vip_Product;
let _vip_chongzhi = Vip_chongzhi;
export default {
    /**
     * mock bootstrap
     */
    bootstrap: function () {
        let mock = new MockAdapter(axios);

        // mock success request
        mock.onGet('/success').reply(200, {
            msg: 'success'
        });

        // mock error request
        mock.onGet('/error').reply(500, {
            msg: 'failure'
        });

        //登录
        mock.onPost('/v1/sso/login').reply(config => {
            let {username, password} = JSON.parse(config.data);
            return new Promise((resolve, reject) => {
                let user = null;
                setTimeout(() => {
                    let hasUser = LoginUsers.some(u => {
                        if (u.username === username && u.password === password) {
                            user = JSON.parse(JSON.stringify(u));
                            user.password = undefined;
                            return true;
                        }
                    });

                    if (hasUser) {
                        resolve([200, {code: 200, msg: '请求成功', user}]);
                    } else {
                        resolve([200, {code: 500, msg: '账号或密码错误'}]);
                    }
                }, 1000);
            });
        });

        //获取用户列表
        mock.onGet('/user/list').reply(config => {
            let {name} = config.params;
            let mockUsers = _Users.filter(user => {
                if (name && user.name.indexOf(name) == -1) return false;
                return true;
            });
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        users: mockUsers
                    }]);
                }, 1000);
            });
        });

        //获取用户列表（分页）
        mock.onGet('/user/listpage').reply(config => {
            let {page, name} = config.params;
            let mockUsers = _Users.filter(user => {
                if (name && user.name.indexOf(name) == -1) return false;
                return true;
            });
            let total = mockUsers.length;
            mockUsers = mockUsers.filter((u, index) => index < 20 * page && index >= 20 * (page - 1));
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        total: total,
                        users: mockUsers
                    }]);
                }, 1000);
            });
        });

        //删除用户
        mock.onGet('/user/remove').reply(config => {
            let {id} = config.params;
            _Users = _Users.filter(u => u.id !== id);
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        code: 200,
                        msg: '删除成功'
                    }]);
                }, 500);
            });
        });

        //批量删除用户
        mock.onGet('/user/batchremove').reply(config => {
            let {ids} = config.params;
            ids = ids.split(',');
            _Users = _Users.filter(u => !ids.includes(u.id));
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        code: 200,
                        msg: '删除成功'
                    }]);
                }, 500);
            });
        });

        //编辑用户
        mock.onGet('/user/edit').reply(config => {
            let {head_url, user_name, pwd, nickname, realname, phone_num, sex, birthday, star_level, is_vip, vip_expire_time, vip_status, status, is_allow_enroll, citycode, areacode, resume} = config.params;
            _Users.some(u => {
                if (u.id === id) {
                    u.head_url = head_url;
                    u.user_name = name;
                    u.pwd = pwd;
                    u.nickname = nickname;
                    u.realname = realname;
                    u.phone_num = phone_num;
                    u.sex = sex;
                    u.age = age;
                    u.birthday = birthday;
                    u.star_level = star_level;
                    u.is_vip = is_vip;
                    u.vip_expire_time = vip_expire_time;
                    u.vip_status = vip_status;
                    u.status = status;
                    u.is_allow_enroll = is_allow_enroll;
                    u.citycode = citycode;
                    u.areacode = areacode;
                    u.resume = resume;
                    return true;
                }
            });
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        code: 200,
                        msg: '编辑成功'
                    }]);
                }, 500);
            });
        });

        //新增用户
        mock.onGet('/user/add').reply(config => {
            let {head_url, user_name, pwd, nickname, realname, phone_num, sex, birthday, star_level, is_vip, vip_expire_time, vip_status, status, is_allow_enroll, citycode, areacode, resume} = config.params;
            _Users.push({
                head_url: head_url,
                user_name: user_name,
                pwd: pwd,
                nickname: nickname,
                realname: realname,
                phone_num: phone_num,
                sex: sex,
                birthday: birthday,
                star_level: star_level,
                is_vip: is_vip,
                vip_expire_time: vip_expire_time,
                vip_status: vip_status,
                status: status,
                is_allow_enroll: is_allow_enroll,
                citycode: citycode,
                areacode: areacode,
                resume: resume
            });
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        code: 200,
                        msg: '新增成功'
                    }]);
                }, 500);
            });
        });


        //获取vip用户列表--------------------------------------------------------------------------------------------
        mock.onGet('/user_vip/list').reply(config => {
            let {nickname} = config.params;
            let mockUsers = _Users_vip.filter(user => {
                if (nickname && user.nickname.indexOf(nickname) == -1) return false;
                return true;
            });
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        users: mockUsers
                    }]);
                }, 1000);
            });
        });

        //获取用户列表（分页）
        mock.onGet('/user_vip/listpage').reply(config => {
            let {page, nickname, sex} = config.params;
            let mockUsers = _Users_vip.filter(user => {
                if (nickname && user.nickname.indexOf(nickname) == -1 || user.sex == user.sex.value) return false;
                return true;
            });
            let total = mockUsers.length;
            mockUsers = mockUsers.filter((u, index) => index < 10 * page && index >= 10 * (page - 1));
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        total: total,
                        users: mockUsers
                    }]);
                }, 1000);
            });
        });

        //删除用户
        mock.onGet('/user_vip/remove').reply(config => {
            let {id} = config.params;
            _Users_vip = _Users_vip.filter(u => u.id !== id);
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        code: 200,
                        msg: '删除成功'
                    }]);
                }, 500);
            });
        });

        //批量删除用户
        mock.onGet('/user_vip/batchremove').reply(config => {
            let {ids} = config.params;
            ids = ids.split(',');
            _Users_vip = _Users_vip.filter(u => !ids.includes(u.id));
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        code: 200,
                        msg: '删除成功'
                    }]);
                }, 500);
            });
        });

        //编辑用户
        mock.onGet('/user_vip/edit').reply(config => {
            // let { head_url, user_name, pwd, nickname, realname, phone_num, sex, birthday, star_level, is_vip, vip_expire_time, vip_status, status, is_allow_enroll, citycode, areacode , resume } = config.params;
            let {head_url, user_name, pwd, nickname, realname, phone_num, sex, birthday, star_level, is_vip, vip_expire_time, vip_status, status, is_allow_enroll, citycode, areacode, resume} = config.params;
            _Users_vip.some(u => {
                if (u.id === id) {
                    u.head_url = head_url;
                    u.user_name = user_name;
                    u.pwd = pwd;
                    u.nickname = nickname;
                    u.realname = realname;
                    u.phone_num = phone_num;
                    u.sex = sex;
                    u.age = age;
                    u.birthday = birthday;
                    u.star_level = star_level;
                    u.is_vip = is_vip;
                    u.vip_expire_time = vip_expire_time;
                    u.vip_status = vip_status;
                    u.status = status;
                    u.is_allow_enroll = is_allow_enroll;
                    u.citycode = citycode;
                    u.areacode = areacode;
                    u.resume = resume;
                    return true;
                }
            });
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        code: 200,
                        msg: '编辑成功'
                    }]);
                }, 500);
            });
        });

        //新增用户
        mock.onGet('/user_vip/add').reply(config => {
            let {head_url, user_name, pwd, nickname, realname, phone_num, sex, birthday, star_level, is_vip, vip_expire_time, vip_status, status, is_allow_enroll, citycode, areacode, resume} = config.params;
            _Users_vip.push({
                head_url: head_url,
                user_name: user_name,
                pwd: pwd,
                nickname: nickname,
                realname: realname,
                phone_num: phone_num,
                sex: sex,
                birthday: birthday,
                star_level: star_level,
                is_vip: is_vip,
                vip_expire_time: vip_expire_time,
                vip_status: vip_status,
                status: status,
                is_allow_enroll: is_allow_enroll,
                citycode: citycode,
                areacode: areacode,
                resume: resume
            });
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        code: 200,
                        msg: '新增成功'
                    }]);
                }, 500);
            });
        });

        //vip充值记录列表----------------------------------------------------------------------------------------------------------------------------
        mock.onGet('/vip_chongzhi/list').reply(config => {
            let {nickname} = config.params;
            let mockUsers = _vip_chongzhi.filter(user => {
                if (nickname && user.nickname.indexOf(nickname) == -1) return false;
                return true;
            });
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        users: mockUsers
                    }]);
                }, 1000);
            });
        });

        //获取vip充值记录列表（分页）
        mock.onGet('/vip_chongzhi/listpage').reply(config => {
            let {page, nickname, sex} = config.params;
            let mockUsers = _vip_chongzhi.filter(user => {
                if (nickname && user.nickname.indexOf(nickname) == -1 || user.sex == user.sex.value) return false;
                return true;
            });
            let total = mockUsers.length;
            mockUsers = mockUsers.filter((u, index) => index < 10 * page && index >= 10 * (page - 1));
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        total: total,
                        users: mockUsers
                    }]);
                }, 1000);
            });
        });

        //删除vip充值记录
        mock.onGet('/vip_chongzhi/remove').reply(config => {
            let {id} = config.params;
            _vip_chongzhi = _vip_chongzhi.filter(u => u.id !== id);
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        code: 200,
                        msg: '删除成功'
                    }]);
                }, 500);
            });
        });

        //批量删除vip充值记录
        mock.onGet('/vip_chongzhi/batchremove').reply(config => {
            let {ids} = config.params;
            ids = ids.split(',');
            _vip_chongzhi = _vip_chongzhi.filter(u => !ids.includes(u.id));
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        code: 200,
                        msg: '删除成功'
                    }]);
                }, 500);
            });
        });

        //获取系统用户列表----------------------------------------------------------------------------------------------------------------------------
        mock.onGet('/user_admin/list').reply(config => {
            let {user_name, roles} = config.params;
            let mockUsers = _Users_admin.filter((user, role) => {
                if (user_name && user.user_name.indexOf(user_name) == -1 || role.roles == value) return false;
                return true;
            });
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        adminusers: mockUsers
                    }]);
                }, 1000);
            });
        });

        //获取系统用户列表（分页）
        mock.onGet('/user_admin/listpage').reply(config => {
            let {page, user_name, roles} = config.params;
            let mockUsers = _Users_admin.filter((user, role) => {
                if (user_name && user.user_name.indexOf(user_name) == -1 || role.roles == 2) return false;
                return true;
            });
            let total = mockUsers.length;
            mockUsers = mockUsers.filter((u, index) => index < 20 * page && index >= 20 * (page - 1));
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        total: total,
                        adminusers: mockUsers
                    }]);
                }, 1000);
            });
        });

        //删除系统用户
        mock.onGet('/user_admin/remove').reply(config => {
            let {id} = config.params;
            _Users_admin = _Users_admin.filter(u => u.id !== id);
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        code: 200,
                        msg: '删除成功'
                    }]);
                }, 500);
            });
        });

        //批量删除系统用户
        mock.onGet('/user_admin/batchremove').reply(config => {
            let {ids} = config.params;
            ids = ids.split(',');
            _Users_admin = _Users_admin.filter(u => !ids.includes(u.id));
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        code: 200,
                        msg: '删除成功'
                    }]);
                }, 500);
            });
        });


        //查看系统用户详情
        mock.onGet('/user_admin/detail').reply(config => {
            let {id, user_name, pwd, full_name, roles, sex, status} = config.params;
            _Users_admin.some(u => {
                if (u.id === id) {
                    u.user_name = user_name;
                    u.pwd = pwd;
                    u.full_name = full_name;
                    u.roles = roles;
                    u.sex = sex;
                    u.status = status;
                    return true;
                }
            });
        });
        //编辑系统用户
        mock.onGet('/user_admin/edit').reply(config => {
            let {id, user_name, pwd, full_name, roles, sex, status} = config.params;
            _Users_admin.some(u => {
                if (u.id === id) {
                    u.user_name = user_name;
                    u.pwd = pwd;
                    u.full_name = full_name;
                    u.roles = roles;
                    u.sex = sex;
                    u.status = status;
                    return true;
                }
            });
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        code: 200,
                        msg: '编辑成功'
                    }]);
                }, 500);
            });
        });

        //新增系统用户
        mock.onGet('/user_admin/add').reply(config => {
            let {user_name, pwd, full_name, roles, sex, status} = config.params;
            _Users_admin.push({
                user_name: user_name,
                pwd: pwd,
                full_name: full_name,
                roles: roles,
                sex: sex,
                status: status
            });
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        code: 200,
                        msg: '新增成功'
                    }]);
                }, 500);
            });
        });

        //获取会员卡列表----------------------------------------------------------------------------------------------------------------------------
        mock.onGet('/VipProduct/list').reply(config => {
            let {name} = config.params;
            let mockUsers = _Vip_Product.filter(user => {
                if (name && user.name.indexOf(name) == -1) return false;
                return true;
            });
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        users: mockUsers
                    }]);
                }, 1000);
            });
        });

        //获取会员卡列表（分页）
        mock.onGet('/VipProduct/listpage').reply(config => {
            let {page, name} = config.params;
            let mockUsers = _Vip_Product.filter(user => {
                if (name && user.name.indexOf(name) == -1) return false;
                return true;
            });
            let total = mockUsers.length;
            mockUsers = mockUsers.filter((u, index) => index < 20 * page && index >= 20 * (page - 1));
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        total: total,
                        users: mockUsers
                    }]);
                }, 1000);
            });
        });

        //删除会员卡
        mock.onGet('/VipProduct/remove').reply(config => {
            let {id} = config.params;
            _Vip_Product = _Vip_Product.filter(u => u.id !== id);
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        code: 200,
                        msg: '删除成功'
                    }]);
                }, 500);
            });
        });

        //批量删除会员卡
        mock.onGet('/VipProduct/batchremove').reply(config => {
            let {ids} = config.params;
            ids = ids.split(',');
            _Vip_Product = _Vip_Product.filter(u => !ids.includes(u.id));
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        code: 200,
                        msg: '删除成功'
                    }]);
                }, 500);
            });
        });

        //编辑会员卡
        mock.onGet('/VipProduct/edit').reply(config => {
            let {id, product_name, day_num, amounts, orig_price, status} = config.params;
            _Vip_Product.some(u => {
                if (u.id === id) {
                    u.product_name = product_name;
                    u.day_num = day_num;
                    u.amounts = amounts;
                    u.orig_price = orig_price;
                    u.status = status;
                    return true;
                }
            });
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        code: 200,
                        msg: '编辑成功'
                    }]);
                }, 500);
            });
        });

        //新增会员卡
        mock.onGet('/VipProduct/add').reply(config => {
            let {product_name, day_num, amounts, orig_price, status} = config.params;
            _Vip_Product.push({
                product_name: product_name,
                day_num: day_num,
                amounts: amounts,
                orig_price: orig_price,
                status: status
            });
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve([200, {
                        code: 200,
                        msg: '新增成功'
                    }]);
                }, 500);
            });
        });


    }
};


// WEBPACK FOOTER //
// ./src/mock/mock.js